export default __webpack_public_path__ + "static/media/friim_sub_bg_1.2624a163.jpg";